exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px){.new-collection[data-v-697d2fb9]{padding-top:0;margin-bottom:0}}@media (max-width: 767px){.new-collection h2[data-v-697d2fb9]{padding:10px 0;font-size:16px}}@media (max-width: 767px){.abobanebt-order[data-v-697d2fb9]{-ms-flex-order:2;order:2}}@media (max-width: 767px){.category-order[data-v-697d2fb9]{-ms-flex-order:1;order:1;margin-left:5px;margin-right:5px}}.logo-box[data-v-697d2fb9]{border-bottom-left-radius:9px;border-bottom-right-radius:9px;padding:10px 0}@media (max-width: 767px){.logo-box[data-v-697d2fb9]{padding:0}}\n", ""]);

// exports
